import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * What TMDB's mapping could not do as configured, after an add or an update
 * (warnings of the API: new_option, option_not_added, option_limit,
 * refused, unmatched, field_missing), named by the fields of the type.
 */
function SourceWarnings({ warnings, fields }) {
  const { t } = useTranslation();
  const shown = (warnings || []).filter(warning => warning.code !== 'unmatched');   // an unmatched value is the owner's choice
  if (shown.length === 0) return null;
  const name = (key) => (fields || []).find(field => field.key === key)?.name || key;
  return (
    <ul className="source-warnings" aria-label={t('sourceWarnings.title')}>
      {shown.map((warning, index) => (
        <li key={index}>
          {t(`sourceWarnings.${warning.code}`, {
            field: name(warning.field),
            attribute: warning.attribute,
            value: warning.value ?? '',
            reason: warning.reason ?? '',
            defaultValue: warning.code,
          })}
        </li>
      ))}
    </ul>
  );
}

export default SourceWarnings;
